import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '70vh',
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  icon: {
    fontSize: 80,
    color: '#bdbdbd',
    marginBottom: theme.spacing(2),
  },
  text: {
    marginBottom: theme.spacing(2),
    fontWeight: 500,
  },
  button: {
    textTransform: 'none',
    fontWeight: 600,
  }
}));

export default useStyles;
